import { TextFieldProps } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { FieldProps, getIn, useFormikContext } from "formik";
import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";

interface Props {
  handleChange?: (value: string) => void;
  disablePast?: boolean;
  disabled?: boolean;
}

const FormikDatePicker: React.FC<FieldProps & TextFieldProps & Props> = (
  props
) => {
  const {
    handleChange: onDateSelected,
    disablePast,
    disabled,
    error,
    form,
    field,
    required,
    ...rest
  } = props;
  const { setFieldValue } = useFormikContext();
  const isTouched = getIn(form.touched, field.name);
  const errorMessage = getIn(form.errors, field.name);

  function handleChange(value: any): void {
    setFieldValue(props.field.name, value);
    onDateSelected?.(value);
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={props.label}
        value={field.value || null}
        disablePast={disablePast}
        disabled={disabled}
        onChange={handleChange}
        slotProps={{
          textField: {
            ...rest,
            fullWidth: true,
            error: error ?? Boolean(isTouched && errorMessage),
            required: required,
          },
        }}
        // slots={{
        //   textField: (params) => <FormikTextField {...params} {...rest} />,
        // }}
      />
    </LocalizationProvider>
  );
};

export default FormikDatePicker;
